import type { ReportColumn } from './types'

export function exportCsv<T>(
  rows: Array<T>,
  columns: Array<ReportColumn<T>>,
  filename: string,
) {
  const header = columns.map((c) => c.label)
  const lines = rows.map((row) =>
    columns.map((col) => {
      const val = col.accessorFn
        ? col.accessorFn(row)
        : (row as Record<string, unknown>)[col.key]
      return String(val ?? '')
    }),
  )
  downloadCsv([header, ...lines], filename)
}

const SEP = ';'

/** Lines of cells as the CSV text: `;`-separated, quoted where needed, with a BOM for Excel. */
export function csvText(lines: Array<Array<string>>): string {
  const bom = '\uFEFF'
  return (
    bom +
    lines
      .map((cells) => cells.map((cell) => csvEscape(cell, SEP)).join(SEP))
      .join('\n')
  )
}

/** Downloads lines of cells as a CSV file — a report with header lines above its table. */
export function downloadCsv(lines: Array<Array<string>>, filename: string) {
  const blob = new Blob([csvText(lines)], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.click()
  URL.revokeObjectURL(url)
}

function csvEscape(value: string, sep: string): string {
  if (value.includes(sep) || value.includes('"') || value.includes('\n')) {
    return '"' + value.replace(/"/g, '""') + '"'
  }
  return value
}
